import React from 'react'
import { css } from 'glamor'
import { propMerge } from 'glamor/react'


const styles = css({
	fontWeight: "600",
})

const H6 = ({ children, ...otherProps }) => {
	return <span {...propMerge(styles, otherProps)}>{children}</span>
}

export default H6
